module.exports = __webpack_public_path__ + "media/src/images/icon/sale-house-d01f68f635a8b492cc55de81d93f79bc.png";